<style scoped>
.margin-bottom {
  margin-bottom: 1rem;
}
</style>

<template>
  <mu-row gutter>
    <mu-col span="12" sm="12" md="12" lg="4" xl="4">
      <mu-card class="margin-bottom">
        <mu-card-text>
          <h3 class="item-title">
            {{$t('multiselect.select') + $t('space') + $t('AnalyticsStudent.student')}}
          </h3>
          <multiselect 
            v-model="user" 
            :options="userOptions"
            label="name"
            track-by="id"
            :close-on-select="false" :clear-on-select="false" :preserve-search="true"
            :selectLabel="$t('multiselect.select')"
            :selectedLabel="$t('multiselect.selected')"
            :deselectLabel="$t('multiselect.deselect')"
            :placeholder="$t('multiselect.select') + $t('space') + $t('AnalyticsStudent.student')"
            searchable>
            <span slot="noResult">$t('multiselect.noResult')</span>
          </multiselect>
        </mu-card-text>
      </mu-card>
    </mu-col>
    <mu-col span="12" sm="12" md="12" lg="8" xl="8">
      <mu-card class="margin-bottom">
        <mu-card-text>
          <h3 class="item-title">
            {{channel.name}}
          </h3>
          <div v-for="child in channel.children">
            <AnalyticsItem :object="child" :userId="user && user.id ? user.id : null" />
          </div>
        </mu-card-text>
      </mu-card>
    </mu-col>
  </mu-row>
</template>

<script>
import langEn from './lang/en.json'
import langZh from './lang/zh.json'

import Multiselect from 'vue-multiselect'

import AnalyticsItem from '@/components/Analytics/Item/Main.vue'

import axios from "axios";

export default {
  name: "AnalyticsStudent",
  props: {
    channel: {
      type: Object,
      required: true
    }
  },
  components: {
    Multiselect,
    AnalyticsItem,
  },
  created() {
    this.$i18n.add('en', langEn); // Add English Translation
    this.$i18n.add('zh', langZh); // Add Traditional Chinese Translation
  },
  data() {
    return {
      enrollments: [],
      
      user: {},
    }
  },
  mounted() {
    this.fetchEnrollments();
  },
  computed: {
    userOptions() {
      if(this.enrollments.length > 0) {
        return this.enrollments.map(i => {
          return {
            name: i.user.name,
            id: i.user._id
          }
        });
      } else {
        return [];
      }
    },
  },
  methods: {
    fetchEnrollments() {
      axios.get(this.$store.getters.urlApi + "enrollment/channel/" + this.channel._id, {
        headers: {
          token: this.$store.state.auth.token
        }
      }).then(response => {
        this.enrollments = response.data.data.enrollments;
      });
    },
  }
};
</script>
